const creditCardsModel = vm => ({
  title: 'Credit Cards',
  endpoint: 'credit-cards',
  allowNew: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country 3 letter ISO code')
    },
    {
      key: 'active',
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('1 or 0')
    }
  ],
  filters: ['id', 'name', 'country_iso_code']
})

export default creditCardsModel
